import React from "react";
import Select from "react-select";
import "./MultiSelect.css";
import { Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';
 
const MultiSelectWrapper = ({
  options,
  onChangeForRegion,
  errors,
  name,
  label,
  is_multi,
  mandatory,
  control,
  disabled = false,
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#000",
    }),
    control: (base, state) => ({
      ...base,
      background: "#252b48",
      fontSize: "12px",
      borderColor: state.isFocused
        ? "#ffa100"
        : errors && errors[name]
        ? "#f4694c"
        : "#001b30",
      border: state.isFocused
        ? "2px solid #ffa100"
        : errors && errors[name]
        ? "1px solid #f4694c"
        : "1px solid #001b30",
      boxShadow: "none",
      alignItems: "flex-start",
      "&:hover": {
        borderColor: state.isFocused ? "#ffa100" : "#001b30",
      },
      ...(disabled && {
        backgroundColor: "#7c8091",
        color: "#7c8091",
        cursor: "not-allowed",
        borderColor: "#7c8091",
        border: "1px solid #7c8091",
      }),
    }),
    valueContainer: (provided) => ({
      ...provided,
      flexDirection: "column",
      alignItems: "flex-start",
      padding: "4px 8px",
      gap: "3px",
    }),
    multiValue: (provided) => ({
      ...provided,
      width: "100%",
      backgroundColor: "#e9ecef",
      borderRadius: "4px",
      margin: "0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#1a2e35",
      fontSize: "12px",
      fontWeight: "400",
      padding: "2px 6px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#6c757d",
      "&:hover": {
        backgroundColor: "#ced4da",
        color: "#1a2e35",
      },
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#17A3A0",
      alignSelf: "flex-start",
      paddingTop: "8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      alignSelf: "flex-start",
      paddingTop: "8px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
 
  const { t } = useTranslation();
 
  return (
    <div id={"container_" + name}>
      <label style={{ color: disabled ? "#6c659d" : "black" }}>
        {t(label)} {mandatory && <span className="asterisk">*</span>}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <Select
            styles={customStyles}
            placeholder={t("multiselectplaceholder")}
            classNamePrefix="react-select"
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: disabled
                ? {}
                : {
                    ...theme.colors,
                    primary25: "#17A3A0",
                    neutral50: "#fff",
                    neutral80: "#fff",
                    primary: "black",
                  },
            })}
            value={value}
            onChange={(selected) => {
              onChange(selected);
              if (typeof onChangeForRegion === "function") {
                onChangeForRegion();
              }
            }}
            options={options}
            isMulti={is_multi === false ? false : true}
            isDisabled={disabled}
         
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
          />
        )}
      />
      <p className="error__message">{errors[name]?.message}</p>
    </div>
  );
};
 
export default MultiSelectWrapper;
 